import { requestApi } from 'api/api'
import {
  ApprovalOperationChallengeRequest,
  ApprovalWorkflowActionPreRequest,
  ApprovalWorkflowActionResponse,
  GovernanceApprovalSettings,
  PendingTransactionsResponse,
  UpdateAccountAprrovers,
} from 'types/approvals'
import { BaseErrorResponse } from 'types/beneficiaries'

// Payout approval settings live in commons approval-service, served via the gateway at API_URL
// (no `/api` prefix). A 404 means the account has no document yet — treat it as empty settings.
const BVNK_PAYOUT_APPROVAL_SETTINGS_URL = '/governance/v1/approval-settings/bvnk_payout'

export const EMPTY_APPROVAL_SETTINGS: GovernanceApprovalSettings = {
  enabledFlows: [],
  approvalBands: [],
}

export const getAccountApprovalsPreference = async (): Promise<GovernanceApprovalSettings> => {
  try {
    return await requestApi({
      baseUrl: process.env.API_URL,
      url: BVNK_PAYOUT_APPROVAL_SETTINGS_URL,
      method: 'GET',
    })
  } catch (error) {
    if ((error as BaseErrorResponse)?.status === 404) {
      return EMPTY_APPROVAL_SETTINGS
    }
    throw error
  }
}

export const getApprovalsTransactions = (
  currentAccountReference: string,
  status: string,
  page: number,
  pageSize: number
): Promise<PendingTransactionsResponse[]> => {
  return requestApi({
    url: `/approval-workflow/v1/payout-logs`,
    method: 'GET',
    params: {
      sort: 'createDate,desc',
      status,
      reference: currentAccountReference,
      page,
      size: pageSize,
    },
  })
}

export const approvalWorkflowActionPreRequest = (
  data: ApprovalWorkflowActionPreRequest
): Promise<ApprovalWorkflowActionResponse> => {
  return requestApi({
    url: '/approval-workflow/v1/action',
    method: 'POST',
    data,
  })
}

export const approvalWorkflowChallengeRequest = (data: ApprovalOperationChallengeRequest) => {
  return requestApi({
    url: '/approval-workflow/operation-authorizations',
    method: 'POST',
    data,
  })
}

export const updateAccountApprovalsPreference = (
  data: GovernanceApprovalSettings
): Promise<GovernanceApprovalSettings> => {
  return requestApi({
    baseUrl: process.env.API_URL,
    url: BVNK_PAYOUT_APPROVAL_SETTINGS_URL,
    method: 'PUT',
    data,
  })
}

export const updateApprovers = (data: UpdateAccountAprrovers): Promise<unknown> => {
  return requestApi({
    url: '/account/user',
    method: 'PUT',
    data,
  })
}
